import { useEffect } from "react";
import "./LogoutPage.scss";
import { GenericActions } from "../../Redux/Generic/GenericAction";
import { AppRoutes } from "../../Constants/AppRoutes";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Spinner } from "@fluentui/react";
import { AppConfig } from "../../Config";

const LogoutPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    // chiude la sessione anche sul server (e il cookie del video); se non risponde si esce lo stesso
    const token = localStorage.getItem("sessionToken");
    if (token) {
      fetch(AppConfig.api.baseUrl + "/logout", {
        method: "POST",
        headers: { Authorization: "Bearer " + token },
        credentials: "same-origin",
      }).catch(() => {});
    }
    setTimeout(() => {
      let s = localStorage.getItem("settings");
      let r = localStorage.getItem("remember-me");
      localStorage.clear();
      if (s) {
        localStorage.setItem("settings", s);
      }
      if (r) {
        localStorage.setItem("remember-me", r);
      }
      (window as any)["SessionExpired"] = false;
      dispatch(GenericActions.setUser(undefined) as any);
      navigate(AppRoutes.APP_LOGIN_PAGE);
    }, 1000);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        height: "100vh",
      }}
    >
      <Spinner label="Logout in corso..." />
    </div>
  );
};

export default LogoutPage;
